import { Menu, MenuProps } from "@mui/material";
import React, { FunctionComponent, ReactElement, SyntheticEvent } from "react";
import useResettableState from "../../hooks/ResettableState";
import ErrorBoundary from "./ErrorBoundary";

interface AMProps extends Omit<MenuProps, "anchorEl" | "open" | "onClose"> {
  anchor: ReactElement;
}

const AnchoredMenu: FunctionComponent<AMProps> = ({ anchor, children, ...props }) => {
  const [menuAnchor, setMenuAnchor, resetMenuAnchor] = useResettableState<Element>();

  const anchorClickHandler = (e: SyntheticEvent) => setMenuAnchor(e.currentTarget);
  const clickableAnchor = React.cloneElement(anchor, {
    onClick: anchorClickHandler,
  });

  const addOnClickProxy = (child: any) => {
    const reactElement = child as ReactElement;
    if (!reactElement || typeof reactElement !== "object") return child;
    const handler = reactElement.props?.onClick;
    const wrappedHandler = (e: SyntheticEvent) => {
      if (handler) handler(e);
      if (!e.defaultPrevented) resetMenuAnchor();
    };
    return React.cloneElement(reactElement, { onClick: wrappedHandler });
  };

  return (
    <ErrorBoundary>
      {clickableAnchor}
      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={resetMenuAnchor} {...props}>
        {React.Children.map(children, addOnClickProxy)}
      </Menu>
    </ErrorBoundary>
  );
};

export default AnchoredMenu;
